import httpConfig from '@/api/config';
import axios from 'axios';
import Qs from 'qs'

//创建错误拦截器
axios.interceptors.response.use(function (res) {
    let data = res.data;
    if (data.status === 'fail') {
        Message.error({
            message: data.message
        });
    }
    return data;
}, function (error) {
    //alert('服务器连接失败，请检查网络。');
    return Promise.reject(error);
});

/**
 * 解析api配置信息
 * @param apiName
 * @returns {{url: string, method: *|string|string|SVGAnimatedEnumeration}}
 */
function parseApiConfig(apiName, domain) {
    let api = httpConfig.apiList[apiName];
    if (!domain) {
        domain = httpConfig.apiDomain;
    }
    let url = domain + api.url;
    url = httpConfig.isHttps ? "https://" + url : "http://" + url;
    let method = api.method;
    return {url, method}
}


/**
 * 构造http请求对象
 * @type {{request: http.request}}
 */
const http = {
    request: function (apiName, params = {}) {
        let apiConfig = parseApiConfig(apiName);
        let axiosConfig = {
            url: apiConfig.url,
            timeout: httpConfig.timeout,
            method: apiConfig.method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        };
        if (apiConfig.method.toLowerCase() === 'post') {
            axiosConfig.data = Qs.stringify(params)
        } else {
            axiosConfig.params = params
        }
        return axios(axiosConfig);
    },
    upload: function (formData) {
        let apiConfig = parseApiConfig('upload', httpConfig.fileDomain);
        let axiosConfig = {
            data: formData,
            url: apiConfig.url,
            timeout: httpConfig.timeout,
            method: apiConfig.method,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        };
        return axios(axiosConfig);
    },
    uploadFile: function (formData) {
        let apiConfig = parseApiConfig('uploadFile', httpConfig.fileDomain);
        let axiosConfig = {
            data: formData,
            url: apiConfig.url,
            timeout: httpConfig.timeout,
            method: apiConfig.method,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        };
        return axios(axiosConfig);
    },
    addViews: function (id, type) {
        this.request('addViews', {id: id, type: type});
    }
}
export default http;
